import { LifeCategory } from '@/supabase'

export const lifeCategories = Object.values(LifeCategory)
